export default "__VITE_ASSET__CIY50NJk__"